// Filter Interfaces - Teams and Pests
// https://lunrjs.com/  (or maybe http://elasticlunr.com/)
// https://lunrjs.com/guides/getting_started.html

import * as $ from 'jquery';
import Debouncer from './Debouncer';

import * as lunr from 'lunr';
import replaceStemerWithOneThatKeepsOriginalAndStems from '../lib/lunr/replaceStemerWithOneThatKeepsOriginalAndStems';

// Documents to be indexed. Look for elements with @data-obj attribute and grabs json from @data-obj
const documents: Array<any> = [];
const $objs = $('.resources .listItem[data-obj]');
const totalFilters: string[] = [];
$objs.each((index, element) => {
	const elementFilters = (JSON.parse(element.getAttribute('data-filters')) as string[]).map(v => v.replace(/[^A-Za-z_0-9]+/g, ''));
	totalFilters.push(...elementFilters);
	const data = {
		id: element.getAttribute('data-id'),
		name: element.querySelector('.listItem__heading span').textContent,
		text: element.querySelector('.listItem__heading ~ :not(.listItem__link)').textContent,
		filters: elementFilters.join(' '),
		objType: element.getAttribute('data-obj'),
		domElement: element
	};
	// console.log(data);
	documents.push(data);
});
const allFilters = totalFilters.filter((v, i, a) => a.indexOf(v, i + 1) === -1);

// console.log(documents);

// Create searchable index of documents
const idx = lunr(function () {
	this.use(replaceStemerWithOneThatKeepsOriginalAndStems);

	const refName = 'id';

	this.ref(refName);	// 'id' is default

	documents.forEach((doc) => {
		// Must inform of fields before indexing
		for (const propName in doc) {
			if (!(this._fields as any)[propName]) {
				//console.log('ADDING', propName)
				this.field(propName);
			}
		}

		// Add document
		//console.log('Adding to index:', doc);
		this.add(doc);
	 } );
});

// Search index
const $searches = $('[data-search-obj]');

const updateResults = (event: JQuery.TriggeredEvent) => {
	const $searchContainer = $(event.target).closest('[data-search-obj]');
	updateSearchResults($searchContainer);

	event.preventDefault();
};
$searches.on('change submit', updateResults);
$searches.on('keyup', new Debouncer(updateResults, false, 1000).run);


// Now, since page just loaded
$searches.each((index, element) => updateSearchResults($(element)));
function updateSearchResults($searchContainer: JQuery) {
	// Construct query
	// https://lunrjs.com/guides/searching.html
	let query = '';

	// Determine object type we are searching
	const objType = $searchContainer.attr('data-search-obj');
	query += '+objType:' + objType;
	// console.log(query);

	// Add value from form input fields to query
	const $fields = $searchContainer.find('[data-search-field]');
	if ($fields.length !== 0) {
		let subquery = '';
		const seenFilters: string[] = [];
		$fields.each((index, element) => {
			const input = element as HTMLInputElement;

			const field = input.getAttribute('data-search-field');
			const type = input.getAttribute('type') || 'text';

			// console.log(field, type);


			let value: string = (type == 'radio' || type === 'checkbox')
				? (input.checked ? (input as HTMLInputElement).value : '')
				: input.value.trim();

			if (field === 'name') {
				if (value) {
					query += value.split(/\s+/g).map(v => ' +*' + v + '*').join('');
				}
			} else if (field === 'filters') {
				const v = value.replace(/[^A-Za-z_0-9]+/g, '');
				if (allFilters.indexOf(v) !== -1) {
					seenFilters.push(v);
				}
			} else {
				// Clean value so it is safe for use in queries
				value = value.replace(/[^\sA-Za-z_\-0-9]+/g, '');

				// Add value to query
				if (value.length > 0) {
					value.split(/\s+/).forEach((value) => {
						if (value.length > 0) {
							if (field === 'name') {
								subquery += ' +*' + value + '*';
							} else {
								subquery += ' ' + field + ':' + value;
							}
						}
					});
				}
			}
		});
		if (seenFilters.length > 0) {
			subquery += seenFilters.map(v => ' +filters:' + v).join('');
			// subquery += allFilters.filter(v => seenFilters.indexOf(v) === -1).map(v => ' -filters:' + v).join('');
		}
		if (subquery.length !== 0) {
			query += '' + subquery + '';
		}
	}

	console.log('Searching for:', query);

	// Conduct search
	const matches: Array<lunr.Index.Result> = idx.search(query);
	const matchIds = matches.map(result => result.ref);
	//console.log('   Results: ', matchIds);

	documents.forEach((doc) => {
		if (doc.objType === objType) {
			// One that we are dealing with
			if (matchIds.indexOf(doc.id) >= 0) {
				// console.log('match', doc.id, doc);
				doc.domElement.setAttribute('search-match', 'true');
				doc.domElement.removeAttribute('hidden');
			} else {
				// console.log('not a match', doc.id, matchIds.indexOf(doc.id));
				doc.domElement.setAttribute('hidden', 'hidden');
				doc.domElement.setAttribute('search-match', 'false');
			}
		}
	});
}